import React from 'react';

/**
 * The drag handle between the pages rail and the editor column.
 *
 * It stretches over the full height of the row so it can be grabbed at any
 * scroll position. All that shows at rest is a hairline; the grip fades in on
 * hover, because a pill parked permanently in the gutter reads as a stray
 * element rather than as a control. The col-resize cursor carries the
 * affordance the rest of the time. Hidden below lg, where the two columns
 * stack and there is nothing to divide.
 */
export function RailResizer({ isResizing, ...separatorProps }) {
  const lineColor = isResizing
    ? 'bg-emerald-500'
    : 'bg-slate-200 dark:bg-slate-700 group-hover:bg-emerald-400 dark:group-hover:bg-emerald-500';

  const gripColor = isResizing
    ? 'bg-emerald-500 border-emerald-500'
    : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 group-hover:border-emerald-400 dark:group-hover:border-emerald-500';

  const gripVisibility = isResizing
    ? 'opacity-100'
    : 'opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100';

  const dotColor = isResizing ? 'bg-white' : 'bg-slate-400 dark:bg-slate-500';

  return (
    <div
      {...separatorProps}
      role="separator"
      aria-orientation="vertical"
      aria-label="Breite der Seitenleiste anpassen"
      tabIndex={0}
      title="Ziehen zum Anpassen, Doppelklick setzt zurück"
      className="group relative hidden lg:flex self-stretch w-5 mx-1.5 shrink-0 items-start justify-center cursor-col-resize touch-none select-none outline-hidden focus-visible:ring-2 focus-visible:ring-emerald-500/60 focus-visible:rounded-full"
    >
      {/* The divider line spans the whole row and is the only thing visible at
          rest, so it stays hairline-thin. */}
      <span
        className={`pointer-events-none absolute inset-y-0 left-1/2 -ml-px w-0.5 rounded-full transition-colors ${lineColor}`}
      />
      <span
        className={`pointer-events-none sticky top-[45vh] flex h-9 w-5 items-center justify-center rounded-full border shadow-xs transition-[opacity,color,background-color,border-color] ${gripColor} ${gripVisibility}`}
      >
        <span className="flex flex-col gap-[3px]">
          <span className={`block h-[3px] w-[3px] rounded-full transition-colors ${dotColor}`} />
          <span className={`block h-[3px] w-[3px] rounded-full transition-colors ${dotColor}`} />
          <span className={`block h-[3px] w-[3px] rounded-full transition-colors ${dotColor}`} />
        </span>
      </span>
    </div>
  );
}
